import { css } from 'styled-components';
import { COLOR_PALETTE } from '../colors/colorPalette.js';

/**
 * Field error styles
 */ const CSSGenerateTextFieldError = (generateColor = false)=>{
    return css`
    ${generateColor ? "color: " + COLOR_PALETTE.red100 + ";" : ""}
    border-color: ${COLOR_PALETTE.red100};
  `;
};

export { CSSGenerateTextFieldError };
